// extracted by mini-css-extract-plugin
export var layoutContainer = "_ay-0";
export var layoutContainerNoRounding = "_ay-6";
export var layoutContainerOpen = "_ay-5";
export var layoutContainerResizing = "_ay-1";
export var mainContent = "_ay-2";
export var resizeDivider = "_ay-3";
export var slidePanel = "_ay-4";